import React from 'react'

export const Container = ({id, className, children}) => (
  <section {...{id}} className={`${className} container`}>
    {children}
  </section>
)
